/* components/SitePopup.ts

The SitePopup component is a placed in theme.liquid as a
global popup that can be used for any kind of content.

*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class SitePopup extends ThemeComponent {
    @Ref() content!: HTMLDivElement;
    @Ref() closeButton!: HTMLButtonElement;

    init() {
        this.$listen(this.closeButton, 'click', () => {
            this.close();
        });

        this.$listen(this, 'click', (event: Event) => {
            const eventTarget = event.target as HTMLElement;
            if (!eventTarget.closest('.site-popup__content')) {
                this.close();
            }
        });
    }

    clearContent() {
        this.content.innerHTML = '';
    }

    public addContent(content: string) {
        this.content.innerHTML = content;
    }

    public open(mode: string) {
        this.classList.add('site-popup--active');
        this.classList.add(`site-popup--${mode}`);
    }

    public close() {
        this.classList.remove('site-popup--active');
        this.clearContent();
    }
}
